import { useTranslation } from 'react-i18next';
import { EditLog, type EditLogEntry } from '../documents/EditLog';

interface FolderEditLogProps {
    editLog: EditLogEntry[];
    hidePreviewOnMobile?: boolean;
}

export function FolderEditLog({
    editLog,
    hidePreviewOnMobile = false,
}: FolderEditLogProps) {
    const { t } = useTranslation();
    const actionLabels: Record<string, string> = {
        created: t('folders.history.actions.created'),
        edited: t('folders.history.actions.edited'),
    };

    return (
        <EditLog
            editLog={editLog}
            hidePreviewOnMobile={hidePreviewOnMobile}
            title={t('folders.history.title')}
            actionLabels={actionLabels}
        />
    );
}
